import styled from '@emotion/styled'
import {typography, margin} from 'styles'

const BodyText = styled.p({
  ...typography.body,
  ...margin.bottom(16),
})

export default BodyText
